import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const AgentsWaitingForYourInputLoadable: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AgentsWaitingForYourInput" */ './AgentsWaitingForYourInput.tsx'
			)
		).AgentsWaitingForYourInput,
});
